var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-entity',{attrs:{"geometry":"primitive: box; width: 1; height: 2; depth: 1;","material":"visible: false"}},[_c(_vm.component,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }